import React, { FC, useCallback } from 'react';
import { IDefaultComponentProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import { FormItem } from './_Item/FormItem';
import styled from './Form.scss';

interface INestedComponents {
  Item: typeof FormItem;
}

interface IProps extends IDefaultComponentProps {
  onSubmit?: () => void;
}

/** Компонент для организации формы */
export const Form: FC<IProps> & INestedComponents = ({ children, className, onSubmit, ...rest }) => {
  const classes = classnames(className, styled.root);

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      onSubmit?.();
    },
    [onSubmit],
  );

  return (
    <form onSubmit={handleSubmit} className={classes} {...rest}>
      {children}
    </form>
  );
};

Form.Item = FormItem;
